module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-inter"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "text-14 font-weight-500 text-grey-black-2"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.number) ? _c('div', {
    staticClass: "text-24 font-weight-600"
  }, [_vm._v(_vm._s(_vm.number))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94b261c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardItem.vue
// module id = 1817
// module chunks = 180